<template>
    <div class="process-step-item">
        <div class="process-step-item__image">
            <img :src="getImagePath(icon)" :alt="title" />
        </div>
        <div class="process-step-item__title">{{ title }}</div>
        <div class="process-step-item__description">{{ description }}</div>
    </div>
</template>

<script lang="ts" setup>
    import { defineProps } from 'vue';

    defineProps<{
        icon: string,
        title: string,
        description: string,
    }>();

    function getImagePath(name: string): string {
        return new URL(`/src/assets/icons/${name}`, import.meta.url).href;
    }
</script>

<style lang="scss" scoped>
    @use './ProcessStepItem.scss' as *;
</style>
